var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{staticClass:"overflowable",attrs:{"fluid":""}},[_c('b-row',[_c('b-col',[_c('incident-open-list'),_c('edit-incident-modal')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }